const apiUrl = process.env.REACT_APP_API_URL;
export const GetInscripcionsIdInscripcionsId = async ( id: string, id_alumne: string, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/inscripcions/${id}/inscripcions/${id_alumne}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
